var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 22,
    viewBox: "0 0 29 22",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.601 11l-4.986 2.66V8.34L17.601 11zM2.518 19.404l.713-.685-.713.685A5.15 5.15 0 006.231 21h16.538a5.15 5.15 0 003.713-1.596A5.49 5.49 0 0028 15.6V6.4a5.49 5.49 0 00-1.518-3.804A5.15 5.15 0 0022.769 1H6.231a5.15 5.15 0 00-3.713 1.596A5.49 5.49 0 001 6.4v9.2c0 1.42.542 2.789 1.518 3.804z",
    stroke: "#333",
    strokeWidth: 2
  })));
};

export default SvgYoutube;